const IDLE_DEADLINE_MS = 1000;

/**
 * Run `work` when the browser is idle.
 *
 * `requestIdleCallback`'s timeout is the deadline: the callback still runs if the
 * browser stays busy. Where the API is missing, a short timer is the same idea.
 * The returned function cancels a callback that has not run.
 */
export function scheduleIdle(work: () => void): () => void {
    if (typeof window.requestIdleCallback === 'function') {
        const id = window.requestIdleCallback(() => work(), { timeout: IDLE_DEADLINE_MS });
        return () => window.cancelIdleCallback(id);
    }

    const id = window.setTimeout(work, 1);
    return () => window.clearTimeout(id);
}
